export default __webpack_public_path__ + "static/media/img10.a7c162dc.jpeg";